import PropTypes from "prop-types";
import {AddressPropTypes} from "./address";
import {SectorLevelPropTypes} from "./sector";
import {IncorporationPropTypes} from "./incorporation";
import {MetricPropTypes} from "./metric";
import {FranchisePropTypes} from "./franchise";
import {PersonPropTypes} from "./person";
import {SocialMediaPropTypes} from "./socialmedia";

// Unified company document shape — docs/superpowers/specs/2026-09-23-unified-company-document-shape.md §4.
// Removed on purpose (spec §4 "removed"): fteHeadcount, totalHeadcount, onlineHeadcount,
// socioeconomic, partition360, alphasearchId, alphasearchIdVariants.

export const ClassificationPropTypes = PropTypes.shape({
  levels: PropTypes.arrayOf(SectorLevelPropTypes)
});

export const ExternalIdsPropTypes = PropTypes.shape({
  zoominfo: PropTypes.string,
  zoominfoUrl: PropTypes.string
});

export const LifecyclePropTypes = PropTypes.shape({
  status: PropTypes.oneOf(["active", "tombstoned"]),
  lastSeenSnapshot: PropTypes.string,
  lastSeenAt: PropTypes.string,
  missedSnapshots: PropTypes.number,
  tombstonedAt: PropTypes.string,
  evidence: PropTypes.object
});

export let CompanyPropTypes = PropTypes.shape({
  stagedId: PropTypes.string,
  primaryName: PropTypes.string,
  alternativeNames: PropTypes.arrayOf(PropTypes.string),
  primaryLocation: AddressPropTypes,
  otherLocations: PropTypes.arrayOf(AddressPropTypes),
  primaryTelephone: PropTypes.string,
  alternateTelephones: PropTypes.arrayOf(PropTypes.string),
  sourcedClassifications: PropTypes.arrayOf(ClassificationPropTypes),
  // Legacy-only; the unified shape never emits it. Kept as a render fallback (FE #651).
  modeledClassifications: PropTypes.arrayOf(ClassificationPropTypes),
  bestClassification: ClassificationPropTypes,
  // Workspace rows carry a stored industry string instead of classifications (DI #566).
  storedIndustry: PropTypes.string,
  descriptive: PropTypes.arrayOf(PropTypes.string),
  keywords: PropTypes.arrayOf(PropTypes.string),
  incorporation: IncorporationPropTypes,
  primaryLogo: PropTypes.string,
  alternateLogo: PropTypes.string,
  primaryWebsite: PropTypes.string,
  alternateWebsites: PropTypes.arrayOf(PropTypes.string),
  harmonizedHeadcount: MetricPropTypes,
  revenue: MetricPropTypes,
  revenuePerEmployee: MetricPropTypes,
  qualityScore: PropTypes.number,
  franchise: FranchisePropTypes,
  people: PropTypes.arrayOf(PersonPropTypes),
  social: SocialMediaPropTypes,
  similarCompanies: PropTypes.arrayOf(PropTypes.string),
  emails: PropTypes.arrayOf(PropTypes.string),
  externalIds: ExternalIdsPropTypes,
  lifecycle: LifecyclePropTypes
})
